export default __webpack_public_path__ + "static/media/reward.145b9aac.svg";